// Jedinstveno pravilo boja za sve statuse / Da-Ne polja u sistemu:
// - positive (zelena): potvrdni / pozitivni statusi
// - negative (crvena): negacije / odbijanja
// - neutral (galena plava): neutralni statusi (predstoji, u toku, istorija)
// Prikaz: src/components/elements/StatusFlag.js.

export const STATUS_TONES = {
  positive: 'positive',
  negative: 'negative',
  neutral: 'neutral',
};

// Da / Ne polja (App, Overena ZK, Slanje notifikacija...).
export const getBooleanTone = (value) =>
  value ? STATUS_TONES.positive : STATUS_TONES.negative;

export const getBooleanLabel = (value) => (value ? 'Da' : 'Ne');

// Status naloga pacijenta.
const ACCOUNT_STATUS_TONES = {
  active: STATUS_TONES.positive,
  blocked: STATUS_TONES.negative,
  deleted: STATUS_TONES.negative,
};

export const getAccountStatusTone = (status) =>
  ACCOUNT_STATUS_TONES[status] || STATUS_TONES.neutral;

// Status mesecne aktivnosti. "(R)" (rezervisana) ima isti ton kao osnovni status.
// Nedostupna = rok jos nije poceo (neutralno); Nedodeljeno = rok istekao bez
// preuzimanja (negativno).
const OCCURRENCE_STATUS_TONES = {
  available: STATUS_TONES.positive,
  taken: STATUS_TONES.positive,
  saved: STATUS_TONES.positive,
  reserved: STATUS_TONES.positive,
  unavailable: STATUS_TONES.neutral,
  missed: STATUS_TONES.negative,
  unassigned: STATUS_TONES.negative,
};

export const getOccurrenceStatusTone = (status) =>
  OCCURRENCE_STATUS_TONES[status] || STATUS_TONES.neutral;

// Obavestenje o aktivnosti. "Javiti" / "Zakazana notif." tek predstoji.
const NOTIFICATION_STATUS_TONES = {
  notification_sent: STATUS_TONES.positive,
  contacted: STATUS_TONES.positive,
  needs_contact: STATUS_TONES.neutral,
  do_not_contact: STATUS_TONES.negative,
};

export const getNotificationStatusTone = (status) =>
  NOTIFICATION_STATUS_TONES[status] || STATUS_TONES.neutral;

// Status terapije.
const THERAPY_STATUS_TONES = {
  current: STATUS_TONES.positive,
  past: STATUS_TONES.neutral,
  missed: STATUS_TONES.negative,
};

export const getTherapyStatusTone = (status) =>
  THERAPY_STATUS_TONES[status] || STATUS_TONES.neutral;

// Status zahteva za dostavu.
const REQUEST_STATUS_TONES = {
  sent: STATUS_TONES.positive,
  pending: STATUS_TONES.neutral,
  cancelled: STATUS_TONES.negative,
};

export const getRequestStatusTone = (status) =>
  REQUEST_STATUS_TONES[status] || STATUS_TONES.neutral;
